import {
  GET_ACCRELEASETRANS,
  GET_ACCRELEASETRANS_ONE,
  GET_ACCRELEASETRANS_SUCCESS,
  GET_ACCRELEASETRANS_FAIL,
  DELETE_ACCRELEASETRANS,
  DELETE_ACCRELEASETRANS_SUCCESS,
  DELETE_ACCRELEASETRANS_FAIL,
  UPDATE_ACCRELEASETRANS,
  UPDATE_ACCRELEASETRANS_SUCCESS,
  UPDATE_ACCRELEASETRANS_FAIL,
  ADD_NEW_ACCRELEASETRANS,
  ADD_ACCRELEASETRANS_SUCCESS,
  ADD_ACCRELEASETRANS_FAIL,
  ACCRELEASETRANS_LOADING,
  ACCRELEASETRANS_RESET,
} from "./actionType";

export const resetAccReleaseTransState = (actionType) => ({
  type: ACCRELEASETRANS_RESET,
  payload: { actionType },
});

export const getAccReleaseTransSuccess = (actionType, data) => ({
  type: GET_ACCRELEASETRANS_SUCCESS,
  payload: { actionType, data },
});

export const getAccReleaseTransFail = (actionType, error) => ({
  type: GET_ACCRELEASETRANS_FAIL,
  payload: { actionType, error },
});

export const getAccReleaseTrans = data => ({
  type: GET_ACCRELEASETRANS,
  payload: data,
});

export const getAccReleaseTransOne = (data) => ({
  type: GET_ACCRELEASETRANS_ONE,
  payload: data,
});

export const getAccReleaseTransLoading = () => ({
  type: ACCRELEASETRANS_LOADING
});

export const deleteAccReleaseTrans = data => ({
  type: DELETE_ACCRELEASETRANS,
  payload: data,
});

export const deleteAccReleaseTransSuccess = data => ({
  type: DELETE_ACCRELEASETRANS_SUCCESS,
  payload: data,
});

export const deleteAccReleaseTransFail = error => ({
  type: DELETE_ACCRELEASETRANS_FAIL,
  payload: error,
});

export const updateAccReleaseTrans = data => ({
  type: UPDATE_ACCRELEASETRANS,
  payload: data,
});

export const updateAccReleaseTransFail = error => ({
  type: UPDATE_ACCRELEASETRANS_FAIL,
  payload: error,
});

export const updateAccReleaseTransSuccess = data => ({
  type: UPDATE_ACCRELEASETRANS_SUCCESS,
  payload: data,
});

export const addNewAccReleaseTrans = data => {
  return{
    type: ADD_NEW_ACCRELEASETRANS,
    payload: data,
  }
};

export const addAccReleaseTransSuccess = data => ({
  type: ADD_ACCRELEASETRANS_SUCCESS,
  payload: data,
});

export const addAccReleaseTransFail = error => ({
  type: ADD_ACCRELEASETRANS_FAIL,
  payload: error,
});